import { render, staticRenderFns } from "./MobileIndex.vue?vue&type=template&id=395e1663&scoped=true"
import script from "./MobileIndex.vue?vue&type=script&lang=js"
export * from "./MobileIndex.vue?vue&type=script&lang=js"
import style0 from "./MobileIndex.vue?vue&type=style&index=0&id=395e1663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e1663",
  null
  
)

export default component.exports